import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
import store from "store2";
import { Message } from "view-design";
let readJSON = function (blob) {
  return new Promise(resolve => {
    try {
      //js中的blob没有没有直接读出其数据的方法，通过FileReader来读取相关数据
      let reader = new FileReader();
      reader.readAsText(blob, "UTF-8");
      //  当读取操作成功完成时调用.
      reader.onload = function (evt) {
        let data = JSON.parse(evt.target.result);
        resolve(data);
      };
    } catch (e) {
      resolve({
        result: -1,
        msg: e.message
      });
    }
  });
};
const exportExcel = async function (method, url, fileName = "") {
  await axios({
    method,
    url,
    // 请求地址
    responseType: "blob",
    // 表明返回服务器返回的数据类型
    headers: {
      language: store.get("language") || "zh-CN"
    }
  }).then(async res => {
    var _res$data$type;
    if (((_res$data$type = res.data.type) === null || _res$data$type === void 0 ? void 0 : _res$data$type.indexOf("application/json")) > -1) {
      let data = await readJSON(res.data);
      if (data.result !== 0) {
        Message.error(data.msg || $t("diprg14", "未知错误"));
      }
      return;
    }
    const blob = res.data;
    const contentDisposition = res.headers["content-disposition"];
    const fileNameForHeader = contentDisposition ? decodeURI(contentDisposition.split("filename=")[1]) : "";
    const downFileName = fileName || fileNameForHeader;
    if ("download" in document.createElement("a")) {
      // 非IE下载
      const elink = document.createElement("a");
      elink.download = downFileName;
      elink.style.display = "none";
      let blobList = [];
      blobList.push(blob);
      elink.href = window.URL.createObjectURL(new Blob(blobList));
      document.body.appendChild(elink);
      elink.click();

      // 释放URL 对象
      window.URL.revokeObjectURL(elink.href);
      document.body.removeChild(elink);
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, downFileName);
    }
  });
};
export default exportExcel;